import $ from "jquery";
import SimpleParallax from "simple-parallax-js/vanilla";

document.addEventListener('DOMContentLoaded', () => {
  let images = document.querySelectorAll('.parallax');
  new SimpleParallax(images, {
    delay: 1,
    scale: 1.15,
    transition: 'cubic-bezier(0,0,0,1)'
  });


  // IntersectionObserverの作成
  const observer = new IntersectionObserver(function(entries) {
    for(let i = 0; i < entries.length; i++) {
      // 領域内なら処理を実行
      if (entries[i].intersectionRatio <= 0) continue;
      showElm(entries[i].target);
    }
  },{
    // オプション
    rootMargin: '-10% 0% -10% 0%'
  });
  // 監視対象の追加
  const elements = document.querySelectorAll('[data-show="advantage"]');
  for(let i = 0; i < elements.length; i++) {
    observer.observe(elements[i]);
  }
  // 領域内に入ったとき実行する処理
  function showElm(e) {
    e.classList.add('is-show');
    observer.unobserve(e);
  }

});
